/**
 * Generate a UUID v4 string
 * Uses crypto.randomUUID() when available, falls back to a polyfill implementation
 * @returns A UUID v4 string
 */
export function generateUUID(): string {
  // Check if crypto.randomUUID is available (modern browsers)
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }

  // Fallback implementation for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
